// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3nIC4","addWidgetButton":"Header_addWidgetButton__2BDql","dashboardTabs":"Header_dashboardTabs__XxoZz","active":"Header_active__2IZtF"};